import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { BrowserRouter as Router } from 'react-router-dom';
import './i18n';
import { ToastContainer } from 'react-toastify';

ReactDOM.render(
  <Router>
    <AccessibilityProvider>
      <App />
      <ToastContainer />
    </AccessibilityProvider>
  </Router>,
  document.getElementById('root')
);

serviceWorker.register();
